<template>
  <div class="row-card">
    <div class="row-card__thumbnail">
      <img
        @error="onImageError"
        @load="hideLoader"
        :alt="regionName"
        :src="getImageUrl(imageName)"
      />
      <span class="image-loader">
        <loading-spinner :size="24" />
      </span>
    </div>
    <div class="row-card__details">
      <h3 class="font-r font-18 mb-4">
        <a class="row-card__link" :href="offersPageUrl" :title="regionName">{{
          regionName
        }}</a>
      </h3>
      <span class="c-orange-default font-m"
        >Od <span class="font-20">{{ price }}</span> zł/os.</span
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "offer-category-row-card",
  props: {
    regionName: String,
    offersPageUrl: String,
    imageName: String,
    price: String,
  },
  data: () => ({
    imageLoaded: false,
  }),
  methods: {
    hideLoader(e) {
      const loaderElem = e.target.nextElementSibling;
      loaderElem.classList.add("_hiding");

      setTimeout(() => {
        loaderElem.remove();
      }, 150);
    },
    onImageError(e) {
      e.target.src =
        "https://media.travelone.pl/travelonecdn/images/regions/offers-categories/default.jpg";
    },
    getImageUrl(image) {
      let imagesPath =
        "https://media.travelone.pl/travelonecdn/images/regions/offers-categories/";

      return imagesPath + "/" + image + ".jpg";
    },
  },
};
</script>

<style lang="scss" scoped>
.row-card {
  background-color: #fff;
  border-radius: 3px;
  display: flex;
  flex-direction: column;
  height: 300px;
  overflow: hidden;
  position: relative;
  backface-visibility: hidden;
  transform: translateZ(0);
  -webkit-transform: translateZ(0) scale(1, 1);

  &__thumbnail {
    background-color: $border-color;
    display: flex;
    flex: 0 0 220px;
    align-items: center;
    flex-shrink: 0;
    overflow: hidden;
    position: relative;

    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      align-items: flex-start;
    }

    > img {
      display: block;
      width: 100%;
      height: auto;
      min-height: 100%;
      object-fit: cover;
      position: absolute;
      backface-visibility: hidden;
      transform: translateZ(0);
    }
  }

  &__details {
    border-color: $border-color;
    border-style: solid;
    border-width: 0 1px 1px 1px;
    border-radius: 0 0 3px 3px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    padding: 0 12px;

    @media(min-width: 1100px) {
      padding: 0 18px;
    }

    > span {
      line-height: 1;
    }
  }

  &__link {
    &,
    &:hover,
    &:focus {
      color: $text-color-default;
      text-decoration: none;
    }

    &:before {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 1;
    }
  }
}

.image-loader {
  background-color: $gray-00;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  transition: opacity 0.2s ease-in-out;

  &._hiding {
    opacity: 0;
  }
}
</style>
